/**
 * Simple Dialog
 * Show text title,catpion and some buttons
 */
import React from 'react';
import PropTypes from 'prop-types';
import ModalDialog from './ModalDialog';

const ModalSimple = ({ title, caption, message, buttons, show, setShow }) => {
  return (
    <ModalDialog
      title={title}
      modalShow={show}
      setModalShow={setShow}
      buttons={buttons}
    >
      <>
        <h5>{caption}</h5>
        <p dangerouslySetInnerHTML={{ __html: message }}></p>
      </>
    </ModalDialog>
  );
};

ModalSimple.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string,
  message: PropTypes.string,
  buttons: PropTypes.array,
  show: PropTypes.bool,
  setShow: PropTypes.func
};

export default ModalSimple;
